/** The field grave (Tag Recovery, 04 §2.3): where a ranger of the company fell on an earlier drop. */

import type { KitBuilder } from './flora';
import { MeshBuilder, place } from './MeshBuilder';
import { capColor } from './snow';

/**
 * A carbine driven muzzle-down into the ground with his helmet on the butt, 1.2 m to the top,
 * and his amber scarf knotted round the stock: the player's colour is what picks it out of a
 * treeline, and says whose it is. Five boxes - exactly the small-prop budget - so there is no
 * mound: the ground under it is the terrain's.
 */
export const fieldGrave: KitBuilder = (p, rng) => {
  const mb = new MeshBuilder();
  // Set by hand, in a hurry: never quite plumb, never square to the map.
  mb.with(place(0, 0, 0, rng.range(0, Math.PI * 2), 1, rng.range(-0.03, 0.03), rng.range(-0.03, 0.03)), () => {
    mb.box(0.07, 0.62, 0.09, p.color('metal.lo'), place(0, 0, 0)); // barrel and fore-end
    mb.box(0.09, 0.2, 0.16, p.color('metal.lo'), place(0, 0.58, 0)); // receiver
    mb.box(0.1, 0.3, 0.17, p.color('timber.lo'), place(0, 0.76, 0)); // stock
    mb.box(0.18, 0.09, 0.22, p.color('playerAccent.0'), place(0, 0.72, 0)); // the scarf
    // Helmet in his army's cloth, dusted white where it snows.
    mb.box(0.42, 0.19, 0.42, { all: p.color('uniformUS.lo'), top: capColor(p, 'uniformUS.mid') }, place(0, 1.02, 0));
  });
  return mb;
};
